export default {"src":"/_next/static/media/boxes-and-lamp.81653e8d.svg","height":51,"width":40,"blurWidth":0,"blurHeight":0};